import { render, staticRenderFns } from "./CustomTabItem.vue?vue&type=template&id=e40a7dde&scoped=true"
import script from "./CustomTabItem.vue?vue&type=script&lang=js"
export * from "./CustomTabItem.vue?vue&type=script&lang=js"
import style0 from "./CustomTabItem.vue?vue&type=style&index=0&id=e40a7dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40a7dde",
  null
  
)

export default component.exports